module.exports = __webpack_public_path__ + "img/volume-close.3a1277e2.svg";